import { IEnvironmentEntity } from '../environment';
export const aiPrediction: IEnvironmentEntity = {
	development: {
		url: process.env.REACT_APP_FRONTEND_AI_PREDICTION_API_URL_DEVELOPMENT,
	},
	staging: {
		url: process.env.REACT_APP_FRONTEND_AI_PREDICTION_API_URL_STAGING,
	},
	production: {
		url: process.env.REACT_APP_FRONTEND_AI_PREDICTION_API_URL_PRODUCTION,
	},
};
